const CLARIFY_CODES = new Set([
	'AVITO_ENUM_UNMAPPED',
	'SOURCE_VALUE_INVALID',
	'MAPPING_MISSING',
	'CATEGORY_UNRESOLVED',
	'CATEGORY_AMBIGUOUS',
	'CATEGORY_NOT_SUPPORTED',
])

const MISSING_CODES = new Set([
	'SOURCE_REQUIRED_MISSING',
	'TARGET_REQUIRED_MISSING',
	'PUBLICATION_CONTEXT_MISSING',
])

function fallbackGroup(diagnostic) {
	if (MISSING_CODES.has(diagnostic.code)) return 'missing'
	if (CLARIFY_CODES.has(diagnostic.code)) return 'clarify'
	return 'technical'
}

function diagnosticGroup(diagnostic) {
	return ['missing', 'clarify', 'technical'].includes(
		diagnostic?.resolutionType
	)
		? diagnostic.resolutionType
		: fallbackGroup(diagnostic || {})
}

function diagnosticKey(diagnostic) {
	return (
		diagnostic.rootCauseKey ||
		(diagnostic.canonicalFieldKey
			? `canonical:${diagnostic.canonicalFieldKey}`
			: diagnostic.targetFieldKey || diagnostic.targetField
				? `target:${diagnostic.targetFieldKey || diagnostic.targetField}`
				: `code:${diagnostic.code}`)
	)
}

function diagnosticLabel(diagnostic) {
	return (
		diagnostic.canonicalFieldLabel ||
		diagnostic.targetFieldLabel ||
		diagnostic.canonicalFieldKey ||
		diagnostic.targetFieldKey ||
		diagnostic.targetField ||
		null
	)
}

function safeMessage(diagnostic, group, label) {
	if (typeof diagnostic.userMessage === 'string' && diagnostic.userMessage.trim()) {
		return diagnostic.userMessage.trim()
	}
	if (group === 'missing') {
		return label
			? `Не заполнено обязательное поле: ${label}`
			: 'Заполните обязательные данные объекта'
	}
	if (diagnostic.code === 'AVITO_ENUM_UNMAPPED') {
		return label
			? `Значение поля «${label}» не поддерживается Авито`
			: 'Выбранное значение не поддерживается Авито'
	}
	if (diagnostic.code === 'SOURCE_VALUE_INVALID') {
		return label
			? `Для поля «${label}» нужно выбрать одно значение`
			: 'Уточните данные объекта'
	}
	if (group === 'clarify') {
		return label ? `Уточните значение поля «${label}»` : 'Уточните данные объекта'
	}
	return 'Не удалось подготовить объявление из-за внутренней ошибки.'
}

function presentationRank(diagnostic) {
	let rank = 0
	if (diagnostic.canonicalFieldLabel) rank += 4
	if (diagnostic.userMessage) rank += 2
	if (diagnostic.code !== 'TARGET_REQUIRED_MISSING') rank += 1
	return rank
}

export function presentAvitoDiagnostics(
	diagnostics,
	{ mode = 'candidate' } = {}
) {
	const raw = Array.isArray(diagnostics) ? diagnostics : []
	const deduplicated = new Map()

	for (const diagnostic of raw) {
		if (!diagnostic || diagnostic.severity !== 'error') continue
		if (mode === 'candidate' && diagnostic.code === 'PUBLICATION_FEED_ID_MISSING') {
			continue
		}
		const group = diagnosticGroup(diagnostic)
		const label = diagnosticLabel(diagnostic)
		const item = {
			key: diagnosticKey(diagnostic),
			group,
			label,
			message: safeMessage(diagnostic, group, label),
			raw: diagnostic,
			rank: presentationRank(diagnostic),
		}
		const current = deduplicated.get(item.key)
		if (!current || item.rank > current.rank) deduplicated.set(item.key, item)
	}

	const items = [...deduplicated.values()].map(item => ({
		key: item.key,
		group: item.group,
		label: item.label,
		message: item.message,
		raw: item.raw,
	}))
	return {
		missing: items.filter(item => item.group === 'missing'),
		clarify: items.filter(item => item.group === 'clarify'),
		technical: items.filter(item => item.group === 'technical'),
		blocking: raw.some(item => item?.severity === 'error'),
		raw,
	}
}
